document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.rmh-give-a');

	blocks.forEach((block) => {
		// Block initialization logic.
	});
});
